import type { MailboxInfo } from "owa-client-types";
import { mutatorAction } from "satcheljs";
import { getUserStore } from "../store/store";

export const clearReadyTimestampMutator: (mailboxInfo: MailboxInfo) => void = mutatorAction("clearReadyTimestamp", (mailboxInfo: MailboxInfo): void => {
    getUserStore(mailboxInfo).readyTimestamp = undefined;
});
